export const setArticlePage = (dispatch, value) => {
  dispatch({ type: "SET_ARTICLE_PAGE", value });
};
